export default __webpack_public_path__ + "static/media/info-message.14dda6b3.png";